'use strict';

import React, { PropTypes } from 'react';
import ClassNameMixin from '../mixins/ClassNameMixin';
import shouldHandleClick from '../utils/shouldHandleClick';
import PureRenderMixin from '../mixins/PureRenderMixin';
import RouterStateMixin from '../mixins/RouterStateMixin';
import SidebarActionCreators from '../actions/SidebarActionCreators';

require('./Link.less');

const Link = React.createClass({
  mixins: [ClassNameMixin, RouterStateMixin, PureRenderMixin],

  propTypes: {
    onClick: React.PropTypes.func,
    propagateClick: React.PropTypes.bool,
    href: React.PropTypes.string,
    to: React.PropTypes.string,
    params: React.PropTypes.object,
    className: React.PropTypes.string,
    title: React.PropTypes.string,
    bold: React.PropTypes.bool,
    active: React.PropTypes.bool,
    withEllipsis: React.PropTypes.bool,
    crossed: React.PropTypes.bool,
    color: React.PropTypes.oneOf([
      'gray', 'green', 'light', 'dark', 'red',
      'facebook', 'twitter', 'google', 'tumblr', 'pinterest'
    ]),
    opaque: React.PropTypes.bool,
    underline: React.PropTypes.oneOf(['never', 'hover', 'always']),
    target: React.PropTypes.oneOf(['_blank']),
    rel: React.PropTypes.string
  },

  contextTypes: {
    router: PropTypes.func
  },

  className: 'Link',

  getDefaultProps: function () {
    return {
      propagateClick: false,
      underline: 'hover'
    };
  },

  getCSSModifiers: function () {
    const underline = this.props.underline;

    return [
      this.props.color,
      this.props.opaque && 'opaque',
      this.props.bold && 'bold',
      this.props.active && 'active',
      this.props.withEllipsis && 'withEllipsis',
      this.props.crossed && 'crossed',
      'underline' + underline[0].toUpperCase() + underline.slice(1)
    ];
  },

  getHref: function () {
    if (this.props.href) {
      return this.props.href;
    }

    if (this.props.to) {
      const { router: { makeHref } = {} } = this.context;
      return makeHref(this.props.to, this.props.params);
    }
  },

  render: function () {
    return (
      <a className={this.getClassName()}
         href={this.getHref()}
         onClick={this.handleClick}
         target={this.props.target}
         rel={this.props.rel}
         title={this.props.title}>
        {this.props.children}
      </a>
    );
  },

  shouldHandleClick: function (e) {
    if (!this.props.onClick && !this.props.to) {
      return false;
    }

    if (this.getHref() && !shouldHandleClick(e)) {
      return false;
    }

    return true;
  },

  handleClick: function (e) {
    const { propagateClick, onClick, to, params } = this.props;
    const { router: { isActive, transitionTo } = {} } = this.context;

    if (!propagateClick) {
      e.stopPropagation();
    }

    if (this.shouldHandleClick(e)) {
      e.preventDefault();

      if (onClick) {
        onClick(e);
        return;
      }

      if (to && !isActive(to, params)) {
        // Check isActive to avoid resetting query
        transitionTo(to, params);
        SidebarActionCreators.hideSidebar();
      }
    }
  }

});

export default Link;



/** WEBPACK FOOTER **
 ** ./atoms/Link.jsx
 **/